module.exports = "img{margin-bottom: 30px; margin-left: 75px}\n\n@media only screen and (max-width: 740px) {\n    img{margin-bottom: 30px; margin-left: 0}\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/user-regi-biller/user-regi-biller.component.css
// module id = ./src/app/user-regi-biller/user-regi-biller.component.css
// module chunks = main